export const list = (dispatch, apiClient) => apiClient
  .call({
    endpoint: 'orderNew/list',
  })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'ORDERNEW_SET', payload: res.data });
    return res;
  });

export const list2 = (dispatch, apiClient, query, skipId) => apiClient
  .call({ endpoint: 'orderNew/list2', data: { query, skipId } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'ORDERNEW_SET', payload: res.data.results });
    return res;
  });

export const create = (dispatch, apiClient, data) => apiClient
  .call({ endpoint: 'orderNew/new', data })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'ORDERNEW_SET', payload: res.data });
    return res;
  });

export const update = (dispatch, apiClient, id, changes) => apiClient
  .call({ endpoint: 'orderNew/update', data: { id, changes } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'ORDERNEW_SET', payload: res.data });
    return res;
  });

export const remove = (dispatch, apiClient, id) => apiClient
  .call({ endpoint: 'orderNew/remove', data: { id } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'ORDERNEW_SET', payload: res.data });
    return res;
  });

export const get = (dispatch, apiClient, id) => apiClient
  .call({ endpoint: 'orderNew/get', data: { id } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'ORDERNEW_SET', payload: res.data.order });
    dispatch({ type: 'CONTAINER_SET', payload: res.data.containers });
    dispatch({ type: 'TASK_SET', payload: res.data.tasks });
    return res;
  });

export const newFrom3DCart = (dispatch, apiClient, reference, locationId) => apiClient
  .call({ endpoint: 'orderNew/newFrom3DCart', data: { reference, locationId } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    return res;
  });



// WEBPACK FOOTER //
// ./app/actions/orderNew.js